<template>
  <div class="form-item__container">
    <div class="form-item__left-col">
      <span class="form-item__label">{{ config.label }}</span>
    </div>
    <div class="form-item__right-col">
      <en-link-selector
        v-model="$$FormData[config.__key]"
        :domain="$$Domain"
        :client-type="clientType"
        :decor-type="decorType"
      />
    </div>
  </div>
</template>

<script>
import { clientType, decorType } from '@/utils/decor-types'

export default {
  name: 'Link',
  data() {
    return {
      clientType,
      decorType
    }
  }
}
</script>

<style scoped lang="scss">

</style>
